export default {
  'app.setting.pagestyle': 'Page style setting',
  'app.setting.pagestyle.light': 'Light style',
  'app.setting.pagestyle.dark': 'Dark style',
  'app.setting.pagestyle.realdark': 'RealDark style',
  'app.setting.themecolor': 'Theme Color',
  'app.setting.navigationmode': 'Navigation Mode',
  'app.setting.content-width': 'Content Width',
  'app.setting.fixedheader': 'Fixed Header',
  'app.setting.fixedsidebar': 'Fixed Sidebar',
  'app.setting.multitab': 'View multitab',
  'app.setting.sidemenu': 'Side Menu Layout',
  'app.setting.topmenu': 'Top Menu Layout',
  'app.setting.content-width.fixed': 'Fixed',
  'app.setting.content-width.fluid': 'Fluid',
  'app.setting.othersettings': 'Other Settings',
  'app.setting.weakmode': 'Weak Mode',
  'app.setting.copy': 'Copy Setting',
  'app.setting.loading': 'Loading theme',
  'app.setting.copyinfo': 'Copy success，please replace defaultSettings in src/config/defaultSettings.js',
  'app.setting.production.hint': 'Setting panel shows in development environment only, please manually modify',
  'app.setting.themecolor.daybreak': 'Daybreak Blue',
  'app.setting.themecolor.dust': 'Dust Red',
  'app.setting.themecolor.volcano': 'Volcano',
  'app.setting.themecolor.sunset': 'Sunset Orange',
  'app.setting.themecolor.cyan': 'Cyan',
  'app.setting.themecolor.green': 'Polar Green',
  'app.setting.themecolor.geekblue': 'Geek Blue',
  'app.setting.themecolor.purple': 'Golden Purple',

  '开始时间': 'Start time',
  '结束时间': 'End time',
  '用户名': 'User name',
  '密码': 'Password',
  '用户编号': 'User id',
  '用户昵称': 'Nickname',
  '状态': 'Status',
  '部门名称': 'Dept name',
  '角色编号': 'Role id',
  '邮箱': 'Email',
  // '手机号': 'Mobile',
  '角色名': 'Role name',
  '权限标识': 'Permission',
  '排序': 'Sort',
  '菜单名称': 'Menu name',
  '图标': 'Icon',
  '组件路径': 'Path',
  '公告编号': 'Id',
  '公告标题': 'Title',
  '公告类型': 'Type',
  'APP通知': 'APP Notice',
  '后台通知': 'Platform Notice',
  '通知': 'Notice',
  '公告': 'Announcement',
  '操作人': 'Operator',
  '简介': 'Remark',
  '公告图片': 'Picture',
  '内容': 'Content',
  '发布': 'Apply',
  '选择用户': 'Select user',

  '新增': 'Add',
  '确定': 'Ok',
  '审核': 'Audit',
  '修改': 'Edit',
  '复制': 'Copy',
  '删除': 'Remove',
  '关闭': 'Close',
  '导出': 'Export',
  '选中导出': 'Select export',
  '导出全部': 'Export All',
  '导出数据': 'Export data',
  '导入': 'Import',
  '查询': 'Query',
  '重置': 'Reset',
  '详情': 'Info',
  '上传': 'Upload',
  '展开': 'Expand',
  '收起': 'Stow',
  '更多': 'More',
  '保存': 'Save',
  '取消': 'Cancel',
  '确认': 'Confirm',
  '返回': 'Back',
  '翻译': 'Translation',
  '刷新缓存': 'Flush cache',
  '禁用': 'Disable',
  '激活': 'Active',
  '提交': 'Submit',
  '审核通过': 'Approve',
  '审核拒绝': 'Reject',
  '返回上一级': 'Back previous',
  '请输入': 'Please enter ',
  '请输入搜索内容': 'Please enter search content',
  '请选择': 'Please select ',
  '是': 'Yes',
  '否': 'No',
  '启用': 'Enable',
  '操作': 'Operation',
  '添加': 'Add',

  '确认删除所选中数据': 'Confirm deletion of selected data?',
  '删除帖子': 'Delete',
  '导入商品': 'Import Products',
  'SKU编码': 'SKU Code',
  '请将电子表格拖拽到此处': 'Drag and drop your spreadsheet here',
  '支持单个上传，也可以点击后选择文件上传': 'Only single file upload is supported. You can also click to select a file.',
  '上传中': 'Uploading...',
  '设为精选': 'Feature',
  '确认删除所选帖子': 'Delete Selected Posts?',
  '确认通过所选帖子': 'Approve Selected Posts?',
  '确认拒绝该帖子': 'Reject This Post?',
  '确认设为精选帖子': 'Feature Selected Posts?',
  '确认取消精选帖子': 'Remove Selected Posts from Featured?',
  '拒绝原因弹窗标题': 'Reason for Rejection',
  '拒绝原因输入默认提示': 'Please enter the reason for rejection.',
  '拒绝原因输入提示': 'Enter the reason for rejecting this post.',
  '拒绝帖子确认': 'Reject Post',
  '删除成功': 'Remove success',
  '确认取消': 'Confirm cancel?',
  '取消成功': 'Cancel success',
  '新增成功': 'Add success',
  '修改成功': 'Edit success',
  '上传成功': 'Upload success',
  '共': 'Total ',
  '条': ' records',
  '默认': 'Default',
  '中等': 'Medium',
  '紧凑': 'Compact',
  '多语言配置': 'Multi-Language configuration',
  '列展示排序': 'Column display/sort',
  '列排序需拖动名称': 'Column sorting requires dragging name',
  '不能为空': ' not be empty',
  '不能小于0': 'Not be zero',
  '语言': 'Language',
  '根节点': 'Root',
  '选择商品': 'Select goods',
  '创建开始时间': 'Create start time',
  '创建结束时间': 'Create end time',
  '是否确认导出': 'Confirm Export?',
  '此操作将导出当前条件下所有数据而非选中数据': 'This will export all data under the current condition instead of the selected data',
  '此操作将导出选中数据': 'This will export the selected data',
  '推荐尺寸': 'Recommended size',
  '是否显示': 'Is display',
  '账号': 'Account',
  '确认密码': 'Confirm password',
  '验证码': 'Captcha',
  '获取验证码': 'Get captcha',
  '秒后可重新获取': 'Seconds later can be re-obtained',
  '登录': 'Login',
  '记住我': 'Remember me',
  '忘记密码': 'Forget password?',
  '设置新密码': 'Set new password',
  '扫码登录': 'Scan code login',
  '第三方登录': 'Third-party login',
  '使用已有账户登录': 'Use existing account login',
  '请输入图形验证码': 'Please enter the graphic verification code',
  '请输入手机号': 'Please enter your phone number',
  '请输入邮箱': 'Please enter your email',
  // '推广者昵称/姓名': 'promoter nickname/name',
  '欢迎': 'Welcome',
  '欢迎回来': 'Welcome back',
  '注册': 'Register',
  '账户': 'Account',
  '待受理': 'Pending',
  '受理中': 'Processing',
  '已完成': 'Completed',
  '意见建议': 'Suggestion',
  '故障报告': 'Fault report',
  '其他': 'Other',
  '充值': 'Recharge',
  '支付': 'Pay',
  '提现': 'Withdraw',
  '冻结': 'Freeze',
  '结算': 'Settlement',
  '提现退回': 'Withdrawal return',
  '待付款':'Waiting for payment',
  '待收货':'Waiting for receipt',
  '待发货':'Waiting for delivery',
  '已取消':'Cancelled',
  '交易关闭': 'Transaction closed',
  '买家申请': 'Buyer application',
  '卖家接受': 'Seller acceptance',
  '买家发货': 'Buyer delivery',
  '退款进行中': 'Refund in progress',
  '退款失败': 'Refund failed',
  '完成': 'Completed',
  '卖家拒绝': 'Seller rejection',
  '买家撤回': 'Buyer withdrawal',
  '举报用户': 'Report user',
  '举报文章': 'Report article',
  '举报评论': 'Report comment',
  '显示': 'Display',
  '隐藏': 'Hide',
  '开屏广告': 'Splash screen ad',
  '站内链接': 'Internal link',
  '站内链接列表': 'Internal link list',
  '首页banner': 'Home banner',
  '商家名称': 'Shop name',
  '商户账号': 'Merchant account',
  '分组名称': 'Group name',
  //未支付
  '未支付': 'Unpaid',
  //成功
  '成功': 'Success',
  //失败
  '失败': 'Failed',
  //进行中
  '进行中': 'In progress',
  //成功但是发生退款
  '成功但是发生退款': 'Success but refund',
  //付款
  '付款': 'Pay',
  //政策条款
  '政策条款': 'Policy terms',
  //帮助中心
  '帮助中心': 'Help center',
  //系统页面
  '系统页面': 'System page',
  //未使用
  '未使用': 'Unused',
  // 已使用
  '已使用': 'Used',
  // 已过期
  '已过期': 'Expired',
  // 已作废
  '已作废': 'Invalid',
  //满减券
  '满减券': 'Full-reduction coupon',
  //折扣券
  '折扣券': 'Discount coupon',
  '运费券': 'Shipping coupon',
  //已通过
  '已通过': 'Approved',
  //已拒绝
  '已拒绝': 'Rejected',
  //工作室名称
  '工作室名称': 'Studio name',
  //按件数
  '按件数': 'Per piece',
  //按重量
  '按重量': 'By weight',
  //物流类型
  '物流类型': 'Logistics type',
  //快递
  '快递': 'Express',
  //物流
  '物流': 'Logistics',
  //国家名称
  '国家名称': 'Country name',
  //提现失败
  '提现失败': 'Withdrawal failed',
  '请输入新密码': 'Please enter new password',
  // '请输入5-20位英文字母、数字或者符号（除空格），且字母、数字和标点符号至少包含两种': 'Please enter 5-20 English letters, numbers or symbols (except spaces), and at least two of the letters, numbers and punctuation marks',
  '请再次输入新密码确认': 'Please enter new password again',
  '两次输入的密码不一致': 'Two passwords are inconsistent',
  '请输入您的账号': 'Please enter your account',
  '用户账号长度必须介于 2 和 20 之间': 'User account length must be between 2 and 20',
  '请输入您的密码': 'Please enter your password',
  '请再次输入您的密码': 'Please enter your password again',
  '请输入验证码': 'Please enter captcha',
  '验证码已发送，请注意查收': 'Captcha has been sent, please check it',
  '恭喜你，您的账号 ': 'Congratulations, your account ',
  '已经注册成功，请登录': 'Has been registered successfully, please login',
  '注册成功': 'Register success',
  '注册失败': 'Register failed',
  '请再次输入新密码': 'Please enter new password again',
  '重置密码成功': 'Reset password success',
  '重置密码失败': 'Reset password failed',
  '重置密码': 'Reset password',

  '正常': 'Normal',
  '停用': 'Disable',
  '开': 'On',
  '关': 'Off',
  '分配角色': 'Assign Roles',
  // '当前选中编号为': 'Currently selected ID: ',
  '的用户吗?': ' user?',
  // '确认': 'Confirm',
  '启用成功': 'Enabled successfully',
  '关闭成功': 'Disabled successfully',
  '启用失败': 'Enable failed',
  '关闭失败': 'Disable failed',
  '启用异常': 'Enable error',
  '关闭异常': 'Disable error',

  '分销名称': 'Name',
  '分销账号': 'Account',
  '分销手机号': 'Phone',
  '分销邮箱': 'Email',
  '分销二维码': 'Qrcode',
  '分销海报图': 'Poster',
  '分销链接': 'Link',
  '分销状态': 'Status',
  '分销等级': 'Level',
  '分销佣金比例': 'Commission rate',
  '分销佣金总额': 'Total commission',
  '佣金来源的用户': 'Commission source user',
  '佣金': 'Commission amount',
  '恢复时间': 'Recover time',
  '创建时间': 'Create time',
  '备注': 'Remark',
  '审核拒绝原因': 'Audit rejection reason',
  '角色': 'Role',
  '用户名不能为空': 'Username cannot be empty',
  '用户昵称不能为空': 'Nickname cannot be empty',
  '部门不能为空': 'Department cannot be empty',
  '密码不能为空': 'Password cannot be empty',
  '用户密码长度必须介于 5 和 20 之间': 'Password length must be between 5 and 20',
  '邮箱不能为空': 'Email cannot be empty',
  '请正确填写邮箱地址': 'Please enter a valid email address',
  '手机号不能为空': 'Mobile cannot be empty',
  '请正确填写手机号': 'Please enter a valid mobile number',
  'add user': 'Add User',
  'edit': 'Edit',
  '位置': 'Position',
  '跳转类型': 'Jump type',
  '广告名称': 'Name',

  '选择申请': 'Select apply',
  '外链': 'Outlink',
  '内容详情': 'Info',
  '是否隐藏': 'Is hidden',
  '展示时长': 'Show times',
  '展示次数': 'Show num',
  '点击次数': 'Click num',
  '跳转次数': 'Jump num',
  '封面图': 'Cover img',
  '详情图': 'Detail img',
  '姓名': 'Name',
  '联系方式': 'Phone',
  '审核状态': 'Audit status',
  '邮箱联系方式': 'Email',
  '网站': 'Website',

  '提交时间': 'Submit time',

  '处理备注': 'Handle remark',
  '查看详情': 'Detail',

  // '入驻时间': 'Entry Date',
  '邀请人员': 'Members',
  '推广订单': 'Orders',
  '总推广人数': 'Total Promoted Users',
  '本月订单': 'Current Month Orders',
  '累计订单': 'Cumulative Orders',
  '下单金额': 'Order Amount',
  // '今日收益': 'Today\'s Earnings',
  // '本月收益': 'Current Month Earnings',
  // '累计收益': 'Cumulative Earnings',
  // '待结算佣金': 'Pending Commission',
  // '可提现佣金': 'Withdrawable Commission',
  '定制单价': 'Pay amount',
  '产品描述': 'Product Description',
  '数量': 'Num',
  '产品图片': 'Product Picture',

  '电话号码': 'Mobile',
  '国家及城市': 'Country and city',

  '原因': 'Reason',
  '采购需求': 'Procurement requirements',
  '联系信息': 'Contact Information',
  '名称类型': 'Name Type',
  '名称': 'Name',
  '发送优惠券': 'Send Coupon',
  '创建订单': 'Create order',
  '商品分类': 'Category',
  '分类名称': 'Category name',
  '分类图片': 'Category pic',
  '上级分类': 'Parent',
  '分类等级': 'Level',
  '是否首页展示': 'Is home visible',
  '是否参与筛选': 'Is filter',
  '添加下级': 'Add subordinate',
  // '优惠券名称': 'Coupon name',
  // '优惠券类型': 'Coupon type',
  // '面额': 'Denomination',
  '折扣': 'Discount',
  '使用范围': 'Scope',
  '满多少元可用': 'Threshold mount',
  '有效期开始时间': 'Valid start time',
  '有效期结束时间': 'Valid end time',
  '是否新人券': 'Is new',
  '是否可积分兑换': 'Is point exchange',
  '发放数量': 'Stock',
  '手动发放': 'Send',
  '领取记录': 'Receive record',
  '领取时间开始': 'Receive time start',
  '领取时间结束': 'Receive time end',
  '过期时间开始': 'Expire time start',
  '过期时间结束': 'Expire time end',
  '使用时间开始': 'Use time start',
  '使用时间结束': 'Use time end',
  // '过期时间': 'Expire time',
  // '使用时间': 'Use time',
  // '领取时间': 'Receive time',
  '删除优惠券': 'Delete',

  '标签名称': 'Label name',
  '颜色': 'Color',
  '任务标题': 'Task title',
  '任务状态': 'Task status',

  '任务图片': 'Task pic',
  '活动时间': 'Task time',
  '任务描述': 'Task desc',

  '奖励积分': 'Task reward',
  '提交记录': 'Task record',
  '主图/视频': 'Main/video',

  '任务详情': 'Task detail',

  '批量上架': 'Batch on sale',
  '查看关联商品': 'Show goods',
  '标签': 'Label',
  '预览': 'Preview',
  '复制链接': 'Copy link',
  '售卖区域': 'Prod area',
  '批量下架': 'Batch off sale',
  '批量复制': 'Batch copy',
  '确认复制': 'Confirm copy?',
  '复制成功': 'Copy success',
  '选择明星': 'Select star',
  '选择俱乐部': 'Select club',
  '选择运费模板': 'Select Freight template',
  '基础信息': 'Basic information',
  '标签信息': 'Label information',
  '规格信息': 'Spec Information',
  '详情信息': 'Goods info',
  '上架成功': 'On sale success',
  '下架成功': 'Off sale success',
  '确认上架': 'Confirm on sale?',
  '确认下架': 'Confirm off sale?',
  '添加规格': 'Add specification',
  '修改规格': 'Edit specification',
  '商品类型': 'Goods type',
  '商品': 'Goods',
  '是否有海报筒': 'IsHavePoster',
  '明星': 'Star',
  '购买人数': 'Order count',
  '已售数量': 'Sale num',
  '实时未付款数量': 'Un pay num',
  '限购数': 'Min buy num',
  '售卖开始时间': 'Sale start time',
  '售卖结束时间': 'Sale end time',
  '售卖结束日期': 'Sale end data',
  '上架时间': 'On sale time',
  '是否多规格': 'Is multiple spec',
  '是否允许合并购买': 'Is allow Merger Purchase',
  '商品颜色': 'Color',
  '商品详情': 'Goods info',
  '市场价': 'Market price',
  '商品售价': 'Market price',
  '是否赠品': 'Is Gift',
  '成本价': 'Cost price',
  '虚拟销量': 'Virtual Sales num',
  '是否展示销量': 'Is show sales num',
  '商品价': 'Price',
  '商品编号': 'Goods code',
  '仓库库存': 'Warehouse inventory',
  '仓库选择': 'Choose warehouse',
  '固定金额': 'Fixed amount',
  '百分比': 'Rate',
  '联盟佣金': 'Alliance commission',
  'SKU编号': 'Sku code',
  'SKU名字': 'Sku name',
  '规格名称': 'Spec name',
  '商品名称': 'Goods name',
  '商品重量': 'Weight',
  '包装单位': 'Unit',
  '单位商品数量': 'Unit count',
  '商品主图': 'Master picture',
  '商品轮播图': 'Carousel graph',
  '商品视频': 'Carousel video',
  '注意': 'Note: Only one video can be uploaded',
  '商品关键词': 'Keyword',
  '使用英文状态下的逗号拼接': 'Use comma concatenation in English',
  '品牌': 'Brand',
  '运费': 'Freight',
  '小计': 'Subtotal',
  '件': 'Item',
  '优惠': 'Discount',
  '合计': 'Total',
  '运费模板': 'Freight template',
  '商品价格': 'Price',
  '活动价格': 'Activity price',
  '秒杀价格': 'Seckill price',
  '团购价格': 'Group price',
  '会员价格': 'Member price',
  "批量修改价格": "batch edit price",
  "请输入价格": "Please enter price",
  "批量修改成功": "batch edit price success",
  "上架": 'On sale',
  '下架': 'Off sale',
  '普通商品': 'Normal goods',
  '秒杀商品': 'Seckill goods',
  '批量改价': 'Batch Update Price',
  '批量改价成功': 'Batch price update successful',
  '批量改价失败': 'Batch price update failed',
  '请输入有效的价格': 'Please enter a valid price',
  '提示': 'Notice',
  '将根据当前筛选条件修改所有符合条件的商品价格，请谨慎操作！': 'The prices of all products matching the current filter criteria will be modified. Please proceed with caution!',
  '修改为价格': 'Set Price To',
  '筛选条件': 'Filter Criteria',
  '分类ID': 'Category ID',
  '无筛选条件（将修改所有商品）': 'No filter criteria (will modify all products)',
  '请输入昵称': 'Please enter nickname',
  '请选择用户等级': 'Please select user level',
  '全选': 'Select All',
  '取消选择': 'Cancel Selection',
  '已选择': 'Selected',
  '订单时间': 'Order time',
  '限购数量': 'Max buy num',
  '商品库存': 'Stock',
  '预警库存': 'Warning Stock',
  '商品状态': 'Goods status',
  '实际销量': 'Sales num',
  '售卖范围': 'Sales Scope',
  '是否推荐': 'Is_recommend',
  '是否新品': 'Is new',
  '是否样品': 'Is Sample',
  '是否日历展示': 'Is show calendar',
  '是否下单即锁单': 'Is order lock',
  '是否精品': 'Is Premium',
  '是否免费领': 'Is Free',
  '是否限购': 'Is max buy',
  '是否爆款': 'Is Best Seller',
  '售后方式': 'Refund type',
  '退款申请时间': 'Refund time',
  '新增分类': 'Create New Category',
  '新增标签': 'New label',
  '注意视频': 'Note: Only one video can be uploaded',
  '是否展示': 'Whether to display',
  '营销设置': 'Marketing Settings',
  '生成sku': 'Generate SKU',
  '退款申请说明': 'Refund application period: After payment, you can apply for a refund within this period',
  '关键词提示': 'Please enter product keywords, separated by English commas',
  '添加规格值': 'Add spec value',
  '规格值': 'Spec value',
  '是否可见': 'Is show',
  '规格图片': 'Spec picture',
  '是否有规格图片': 'Is have picture',
  '编码': 'Sku code',
  '价格': 'Sku price',
  '库存': 'Stock',
  '原始库存': 'SourceStock',
  '增加/减少库存': 'Add/sub stock',
  '重量': 'Weight',
  '图片': 'picture',
  '品牌名称': 'Brand name',
  '品牌备注': 'Remark',
  '品牌首字母': 'First word',
  'logo': 'Logo',
  '明星名字': 'Star name',
  '明星分类': 'Category',
  '明星照片': 'Star picture',
  '背景图': 'Background picture',
  '基础粉丝数': 'Fans num',
  '网址': 'Web url',
  '关注数': 'Focus num',
  '明星介绍': 'Info',

  '活动编号': 'Id',
  '商品最大购买数量': 'Max buy num',
  '选择活动': 'Select activity',
  '排行': 'Rank',
  '是否上架': 'Is onsale',
  '活动类型': 'Activity type',
  '活动名称': 'Activity name',

  '活动封面图': 'Cover picture',
  '分享海报图': 'Poster picture',
  '分享文案': 'Poster text',
  '限制会员等级': 'Limit level',
  '最多参与次数': 'Maximum',
  '活动详情': 'Activity info',
  '是否展示到日历': 'Is show calendar',
  '时间段': 'Time slot',
  '每天': 'Even day',
  '单用户限购数': 'User limit',
  '添加时段': 'Add time slot',
  '活动参与区域': 'Scope',
  '计费方式': 'Method',
  '模板名称': 'Name',
  '编号': 'No',

  '应援地址': 'Support Address',
  '收货区域': 'Receiving Area',
  '收货人手机号': 'Mobile',
  '身份证号': 'Id card',
  '确认拒绝选中数据': 'Confirm to reject selected data?',
  '确认通过选中数据': 'Confirm to pass selected data?',
  '拒绝成功': 'Reject success',
  '联系电话': 'Contact Phone',
  '广告简介': 'Advertising Introduction',
  '广告活动开始时间': 'Start time',
  '广告活动结束时间': 'End time',
  '是否通过': 'Is pass',

  '会员等级名称': 'Level Name',
  '等级图片': 'Level picture',
  '等级图标': 'Icon',
  '会员等级排序': 'Sort',
  '升级所需积分': 'Upgrade score',
  '会员权益': 'Membership Benefits',
  '消费金额': 'Consumption amount',
  '赠送优惠券张数': 'Number of coupons given away',
  '折扣比例%': 'Discount rate%',
  '消费金额(美元)': 'Consumption amount($)',
  '专属折扣比例': 'Discount rate',
  '权益介绍': 'Membership Benefits',
  '至': 'To',
  '此等级消费最低金额': 'Minimum consumption amount for this level',
  '此等级消费最大金额': 'Maximum consumption amount for this level',
  '会员等级': 'User level',
  '搜索次数': 'Search num',
  '发货方式': 'Delivery type',
  '发货人手机号': 'Delivery mobile',
  '发货时间': 'Delivery time',
  '发货记录编号': 'Delivery id',
  '发货开始时间': 'Delivery start time',
  '发货结束时间': 'Delivery end time',


  '用户信息': 'User info',
  '结算信息': 'Settle info',

  '全部订单': 'All',
  '此操作将导出当所有待发货订单而非选中数据': 'This will export the data when all pending orders are not selected',
  '导出待发货': 'Export to be shipped',
  '导入发货单': 'Import Shipment Doc',
  '订单商品导出': 'Export order items',
  'wms处理状态': 'WMS transaction state',
  '发货仓库': 'Shipping warehouse',
  '接单': 'Orders',
  '接单成功': 'Orders success',
  '物流公司': 'Import Shipment Doc',
  '物流单号': 'Logistics document number',
  '物流明细': 'Logistics Details',
  '物流详情': 'Logistics Details',
  '寄件人手机号': 'Sender Mobile Number',
  '订单编号': 'Number',
  '订单来源': 'Source',
  '订单类型': 'Type',
  '订单数量': 'Quantity',
  '订单信息': 'Information',
  '订单详情': 'Details',
  '三方订单号': 'Tripartite Order Number',
  '买家ID': 'Buyer Id',
  '买家名称': 'Buyer Name',
  '下单总数': 'Order Total',
  '买家信息': 'Buyer Information',
  '手机号或邮箱': 'Phone or email',
  '订单状态': 'Status',
  '下单时间': 'CreateTime',
  '下单开始时间': 'BeginTime',
  '下单结束时间': 'EndTime',
  '支付方式': 'Method',
  '支付时间': 'PayTime',
  '退款状态': 'Refund Status',
  '商品数量': 'Quantity of goods',
  '商品金额': 'Amount',
  '商品实付金额': 'Pay Amount',
  '优惠金额': 'Discount Amount',
  '订单金额': 'Order Amount',
  '运费金额': 'Freight',
  '税费': 'Tax amount',
  '运费实付': 'Freight Paid',
  '用户备注': 'User Remarks',
  '商品信息': 'Information',
  '活动信息': 'Activity',
  '收货地址信息': 'Receiving address information',
  '实付单价': 'Actual unit price',

  '收货人姓名': 'Receiver Name',
  '性别': 'Sex',

  '地址类型': 'Address type',
  '地区': 'Nation',
  '详细地址': 'Address detail',
  '发货': 'Receive',
  '发货成功': 'Success',
  '取消订单': 'Cancel',
  '锁单时间': 'Lock time',
  '发货备注': 'Remark',
  '收货地址': 'Address',

  '订单原价': 'Original order price',
  '实付金额': 'Actual amount paid',
  '是否首单': 'Is first order',
  '是否催发货': 'Is remind',
  '应募信息': 'Recruitment information',
  '是否异常单': 'Is error',
  '异常单开始时间': 'Error start time',
  '异常单结束时间': 'Error end time',

  '原订单编号': 'Original Order Number',
  '售后单编号': 'After-sales order number',
  '售后类型': 'After-sales type',
  '售后状态': 'After-sales status',
  '售后凭证': 'After-sales Voucher',
  '购买数量': 'Purchase Quantity',
  '售后数量': 'After-sales quantity',
  '申请开始时间': 'Application start time',
  '申请结束时间': 'Application end time',
  '退款金额': 'Refund amount',
  '申请时间': 'Application time',
  '售后原因': 'After-sales reasons',
  '售后信息': 'After-sales information',
  '原订单信息': 'Original Order Information',
  '售后详情': 'After-sales details',
  '售后商品': 'After-sale goods',

  '是否同意': 'Agree or not',
  '拒绝原因': 'Reason for rejection',
  '审核成功': 'Approved',
  '退款': 'Refund',
  '是否确认退款': 'Is refund',
  '退款成功': 'Refund success',


  '用户ID': 'User id',
  '发送消息': 'Send message',

  '用户等级': 'Level',
  '积分': 'Score',
  '昵称': 'Nick name',
  '头像': 'Avatar',
  '微信': 'Wechat',
  '真实姓名': 'Real name',
  '身份证': 'Idcard',

  '生日': 'Birthday',
  '邀请码': 'Invitation Code',
  '注册时间': 'Create time',
  '用户状态': 'Status',
  '用户等级名称': 'Level name',
  '用户等级排序': 'Level sort',
  '用户等级图标': 'Level icon',
  '用户等级描述': 'Level description',
  '国家': 'Country',
  '最后登录时间': 'Last login time',
  '下单次数': 'Order count',
  '最小下单次数': 'min count',
  '最大下单次数': 'max count',
  '下单总金额': 'Total order amount',
  '积分值': 'Score',
  '注册渠道': 'Register channel',
  '用户余额': 'Balance',
  '个人简介': 'Personal Profile',

  '变动的积分数': 'Score',
  '变动前剩余积分': 'Before score',
  '变动后剩余积分': 'After score',
  '变动类型': 'Change type',
  '账单类型': 'Bill type',
  '支付类型': 'Pay type',
  '余额类型': 'Balance type',
  '三方支付单号': 'Third-party payment order number',
  '操作前余额': 'Balance before operation',
  '操作后余额': 'Balance after transaction',
  '变动余额': 'Change balance',
  '类型': 'Type',
  '方向': 'Direction',

  '注销原因': 'Cancel reason',
  '审核失败原因': 'Failure Reason',
  '审核人': 'Reviewer',
  '审核时间': 'Review time',
  '注销时间': 'Logout time',
  '待审核': 'Review',
  '失败原因': 'Reason for failure',
  '审核失败': 'Rejection',
  '注销原因不能为空': 'The cancellation reason cannot be empty',
  '拒绝原因不能为空': 'The reason for rejection cannot be empty',
  '审核状态不能为空': 'The audit status cannot be empty',
  '搜索内容': 'Search Content',

  '用户': 'User',
  '处理状态': 'Status',
  '反馈图片': 'Picture',
  '处理': 'Process',
  '反馈类型': 'Type',
  '反馈内容': 'Content',
  '处理结果': 'Result',
  '请输入处理结果': 'Please enter the processing result',
  '公司名称': 'Company Name',
  '公司编码': 'Company Code',
  '公司类型': 'Company Type',
  '公司logo': 'Logo',
  '是否选用': 'Whether selected',


  '账单日期': 'Bill date',
  '账单月份': 'Bill month',
  '交易单号': 'Trade no',
  'ip': 'Ip',
  '交易类型': 'Trade type',
  '支付金额': 'Pay amount',
  '账期金额': 'Billing Amount',
  '手续费': 'Fee',
  '支付信息': 'Payment Information',
  '三方支付流水号': 'Out pay no',
  '支付状态': 'Pay status',
  '交易完成时间': 'Pay time',
  '常见问题标题': 'Title',
  '常见问题简述': 'Title',
  '问题分类': 'Category',
  '常见问题内容': 'Content',
  '显示顺序': 'Sort',
  '创建人': 'Creator',
  '插入时间': 'Create time',
  '推荐关键词': 'Recommended Keywords',
  '关键词': 'Keywords',
  '搜索量': 'Search Volume',
  '所属板块': 'Belonging Section',
  '主键ID': 'Primary Key ID',
  '商品ID': 'Product ID',
  '商品主图URL': 'Product Main Image URL',
  '所属广告位': 'Assigned Ad Slot',
  '立即启用': 'Enable Immediately',
  '商城': 'Mall',
  '发现': 'Discover',
  '用户手机号': 'Phone',
  '提现金额': 'Amount',
  '银行名称': 'Bank Name',
  '银行卡号': 'Card Number',
  '提现方式': 'Method',
  '是否成功': 'Successful',
  '失败信息原因': 'Failure Reason',
  '转账凭证': 'Transfer Voucher',
  '提现到账时间': 'Arrival Time',
  '银行卡': 'Bank',
  '标题': 'Title',
  '频道': 'Channel',
  '草稿箱': 'Drafts',
  '审核中': 'Under Review',
  '人工审核': 'Manual Review',
  '机审拒绝': 'Rejected by System Review',
  '人审拒绝': 'Rejected by Manual Review',
  '举报下架': 'Removed Due to Report',
  '发布成功': 'Published Successfully',
  '主动下架': 'Voluntarily Removed',
  '话题': 'Topic',
  '图文': 'Image & Text',
  '视频': 'Video',
  '帖子图文类型': 'Image',
  '帖子视频类型': 'Video',
  '上架状态': 'Listing Status',
  '设置推荐': 'Set as Recommended',
  '取消推荐': 'Cancel Recommendation',
  '浏览量': 'Page Views',
  '评论量': 'Number of Comments',
  '点赞量': 'Number of Likes',
  '收藏量': 'Number of Favorites',
  '推荐': 'Recommended',
  '发布时间': 'Publication Time',
  '作者用户ID': 'Author User ID',
  '作者昵称快照': 'Author Nickname Snapshot',
  '帖子标题': 'Post Title',
  '帖子内容': 'Post Content',
  '内容类型': 'Content Type',
  '素材URL': 'Material URL',
  '帖子状态': 'Post Status',
  '机审结果': 'System Review Result',
  '机审分数': 'System Review Score',
  '机审标签': 'System Review Tags',
  '人审结果': 'Manual Review Result',
  '拒绝下架原因': 'Reason for Rejection/Removal',
  '作者名称': 'Author Name',
  '帖子ID': 'Post ID',
  '人工排序值': 'Manual Sort Order',
  '是否启用': 'Is Enabled',
  '文章ID': 'Article ID',
  '话题ID': 'Topic ID',
  '作者': 'Author',
  '话题名称': 'Topic Name',
  '用户id': 'User ID',
  '收藏时间': 'Favorites Time',
  '评论开始时间': 'Comment Start Time',
  '评论结束时间': 'Comment End Time',
  '查看回复': 'View Replies',
  '评论内容': 'Comment Content',
  '是否作者评论': 'Is Author Comment',
  '评论用户': 'Commenting User',
  '评论时间': 'Comment Time',
  '回复ID': 'Reply ID',
  '回复内容': 'Reply Content',
  '回复人': 'Replier',
  '是否作者回复': 'Is Author Reply',
  '回复开始时间': 'Reply Start Time',
  '回复结束时间': 'Reply End Time',
  '选择帖子': 'Select Post',
  '举报人姓名': 'Reporter Name',
  '举报类型': 'Report Type',
  '举报开始时间': 'Report Start Time',
  '举报结束时间': 'Report End Time',
  '被举报内容': 'Reported Content',
  '举报图片': 'Report Images',
  '描述': 'Description',
  '举报状态': 'Report Status',
  '举报时间': 'Report Time',
  '被举报内容ID': 'Reported Content ID',
  '举报人ID': 'Reporter ID',
  '举报描述': 'Report Description',
  '处理人ID': 'Handler ID',
  '处理人姓名': 'Handler Name',
  '处理时间': 'Handling Time',
  '频道名称': 'Channel Name',
  '使用次数': 'Use num',
  '业务流水号': 'Business Serial Number',
  '规格': 'Specification',
  '用户价格': 'User Price',
  '加购数量': 'Quantity',
  '电话': 'Phone',
  '邮编': 'Postal Code',
  '所在地': 'Location',
  '省市区': 'Province/City/District',
  '是否默认': 'Is Default',
  '序号': 'ID',
  '余额': 'Balance',
  '冻结金额': 'Frozen Amount',
  '总消费金额': 'Total Expense',
  '总收入金额': 'Total Income',
  '可提现金额': 'Withdrawable Amount',
  '变动时间': 'Change Time',
  '收款人信息': 'Payee Information',
  '账户类型': 'Account Type',
  '收款二维码': 'Payment QR Code',
  '到账金额': 'Actual Amount',
  '转账状态': 'Transfer Status',

  // points module
  '任务名称': 'Task name',
  '增加积分': 'Increase points',
  '兑换编号': 'Redeem no',
  '兑换单号': 'Redeem no',
  '兑换对象ID': 'Redeem target ID',
  '兑换时间': 'Redemption time',
  '消费积分': 'Consumption Points',

  // dataoverview
  '在售商品数': 'On Sale Products',
  '今日上架产品数': "Today's New Products",
  '注册用户数': 'Registered Users',
  '昨日交易额': "Yesterday's Transaction Amount",
  '商品类目占比': 'Product Category Proportion',
  '会员级别占比': 'Member Level Proportion',
  '商品销量': 'Product Sales',
  '经营数据': 'Business Data',
  '总金额': 'Total Amount',
  '总销售额': 'Total Sales',
  '总单量': 'Total Orders',
  '注册曲线': 'Registration Curve',

  // searchpage.vue
  '搜索大屏': 'Search Dashboard',
  '搜索用户数柱图': 'Search User Count Bar Chart',
  '近7天搜索下单量': 'Search Orders in Last 7 Days',
  '近7天日搜词': 'Daily Search Words in Last 7 Days',
  '近7天搜索统计': 'Search Statistics in Last 7 Days',
  '次数': 'Times',
  '搜索用户数': 'Search User Count',
  '关键词数': 'Keyword Count',
  '人均搜索量': 'Average Search Volume',
  '近7天搜索曲线': 'Search Curve in Last 7 Days',
  '近7天搜索方式分布': 'Search Method Distribution in Last 7 Days',
  '近7天使用终端分布': 'Terminal Distribution in Last 7 Days',
  '近7天搜索用户排行': 'Search User Ranking in Last 7 Days',

  // userPortrait.vue
  '用户画像大屏': 'User Portrait Dashboard',
  '当前统计数据': 'Current Statistics',
  '用户总数': 'Total Users',
  '未成单用户数': 'Non-order Users',
  '总下单用户数': 'Total Order Users',
  '近7天下单': 'Orders in Last 7 Days',
  '近14天下单': 'Orders in Last 14 Days',
  '近30天下单': 'Orders in Last 30 Days',
  '余额大于0': 'Balance > 0',
  '余额大于50': 'Balance > 50',
  '余额大于100': 'Balance > 100',
  '余额大于500': 'Balance > 500',
  '性别和年龄': 'Gender and Age',
  '年龄': 'Age',
  '注册曲线图': 'Registration Curve',
  '用户标签排行': 'User Tag Ranking',
  '消费用户统计': 'Consumption User Statistics',
  '消费0-100：': 'Consumption 0-100:',
  '消费100-500：': 'Consumption 100-500:',
  '消费500-1000：': 'Consumption 500-1000:',
  '消费1千-5千：': 'Consumption 1k-5k:',
  '消费5千-1万：': 'Consumption 5k-10k:',
  '消费1万以上：': 'Consumption > 10k:',
  '注册方式和终端': 'Registration Method and Terminal',
  '注册方式': 'Registration Method',
  '注册终端': 'Registration Terminal',
  '会员等级分布': 'Member Level Distribution',

  // workbench.vue
  '支付订单数': 'Payment Order Count',
  '支付用户数': 'Payment User Count',
  '转化率': 'Conversion Rate',
  '客单价': 'Customer Unit Price',
  '单均价': 'Average Order Price',
  '新增用户': 'New Users',
  '转化率/客单价': 'Conversion Rate/Unit Price',
  '财务': 'Finance',
  '自营毛利': 'Self-operated Gross Profit',
  '自营毛利率': 'Self-operated Gross Profit Rate',
  '退款单数': 'Refund Order Count',
  '流量趋势图': 'Traffic Trend Chart',
  'AARRR漏斗': 'AARRR Funnel',
  '类目销售饼状图': 'Category Sales Pie Chart',
  '订单趋势图': 'Order Trend Chart',
  '商品销量排行': 'Product Sales Ranking',
  '加入购物车排行榜': 'Add to Cart Ranking',

  '今日': 'Today',
  '昨日': 'Yesterday',
  '销量': 'Sales',
  '销售单数': 'Sales Order Count',
  '销售件数': 'Sales Item Count',
  '销售金额': 'Sales Amount',
  '保密': 'Secret',
  '男': 'Male',
  '女': 'Female',
  '商品分类占比': 'Product Category Proportion',
  '成交商品': 'Transaction Goods',
  '成交客户': 'Transaction Users',
  '均单价': 'Average Unit Price',
  '销售额': 'Sales Amount',
  '访客数': 'Visitor Count',
  '支付订单金额': 'Payment Order Amount',
  '地域分布': 'Geographical Distribution',
  '今日销量': 'Today\'s Sales',
  '下单数': 'Order Count',
  //付款单量
  '付款单量': 'Payment Order Count',
  //付款客户
  '付款客户': 'Payment Users',
  //下单支付量
  '下单支付量': 'Order Payment Amount',
  //下单量
  '下单量': 'Order Count',
  //支付量
  '支付量': 'Payment Amount',
  //付款金额
  '付款金额': 'Payment Amount',
  //售后分析
  '售后分析': 'After-sales Analysis',
  //实时订单
  '实时订单': 'Real-time Orders',
  //排名
  '排名': 'Rank',
  //商品总金额
  '商品总金额': 'Total Product Amount',
  //已售后金额
  '已售后金额': 'After-sales Amount',
  //下单支付率
  '下单支付率': 'Order Payment Rate',
  //售后单数
  '售后单数': 'After-sales Order Count',
  //售后金额
  '售后金额': 'After-sales Amount',
  //累计数量
  '累计数量': 'Total Count',
  //日用户增长
  '日用户增长': 'Daily User Growth',
  //交易金额
  '交易金额': 'Transaction Amount',
  //支付订单数量
  '支付订单数量': 'Payment Order Count',
  //记录数量
  '记录数量': 'Record Count',
  //订单取消率
  '订单取消率': 'Order Cancellation Rate',
  //订单退款率
  '订单退款率': 'Order Refund Rate',
  //实时交易驾驶舱
  '实时交易驾驶舱': 'Real-time Transaction Dashboard',
  //单
  '单': 'Unit',
  //人
  '人': 'Person',
  //多云
  '多云': 'Multi-cloud',
  //联盟分析大屏
  '联盟分析大屏': 'Alliance Analysis Dashboard',
  //联盟订单交易金额
  '联盟订单交易金额': 'Alliance Order Transaction Amount',
  //联盟订单
  '联盟订单': 'Alliance Order',
  //近一月联盟用户完成单量
  '近一月联盟用户完成单量': 'Alliance User Order Count in Last 1 Month',
  //联盟用户总数
  '联盟用户总数': 'Alliance User Total',
  //联盟邀请注册
  '联盟邀请注册': 'Alliance Invitation Register',
  //近7天分销单数
  '近7天分销单数': 'Distributor Order Count in Last 7 Days',
  //近7天分佣金额
  '近7天分佣金额': 'Distributor Commission Amount in Last 7 Days',
  //近7天分销订单金额
  '近7天分销订单金额': 'Distributor Order Amount in Last 7 Days',
  //近一月联盟邀请用户
  '近一月联盟邀请用户': 'Alliance Invitation User in Last 1 Month',
  //近一月联盟订单金额
  '近一月联盟订单金额': 'Alliance Order Amount in Last 1 Month',
  //联盟用户增长
  '联盟用户增长': 'Alliance User Growth',
  //联盟用户累计
  '联盟用户累计': 'Alliance User Cumulative',
  //近一月联盟商品
  '近一月联盟商品': 'Alliance Product in Last 1 Month',
  //完成单量
  '完成单量': 'Completed Order Count',
  //成员数量
  '成员数量': 'Member Count',
  //商品单价
  '商品单价': 'Product Unit Price',
  //奖励总额度
  '奖励总额度': 'Total Reward Amount',
  //邀请用户
  '邀请用户': 'Invitation User',
  //拉新用户数
  '拉新用户': 'New User Count',
  //新订单
  '新订单': 'New Order',
  //留存用户
  '留存用户': 'Retention User',
  //复购订单
  '复购订单': 'Re-order Order',
  //裂变访问
  '裂变访问': 'Viral Visit',

  // statistics/index.vue
  '总交易额': 'Total Transaction Amount',
  '今日新增用户数': "Today's New Users",
  '今日新增邀请用户数': "Today's New Invited Users",
  '昨日同时段': 'Same Period Yesterday',
  '元': 'Yuan',
  '个': 'Count',
  '按天': 'By Day',
  '按月': 'By Month',
  '按年': 'By Year',
  'RFM 客户分群统计': 'RFM Customer Segmentation Statistics',
  //新建物流时效
  '新建物流时效': 'New Logistics Time',
  //仓库处理时间
  '仓库处理时间': 'Warehouse Processing Time',
  //配送时间
  '配送时间': 'Delivery Time',
  //开启
  '开启': 'Enable',
  //天
  '天': 'Day',

  // role module
  '确认要': 'Confirm to ',
  '的角色吗': ' role?',
  '脱敏权限': 'Mask permission',
  '分配用户': 'Assign users',
  // '的数据': ' data',
  '失败,': ' failed, ',
  '异常': ' error',
  // '确认删除所选中数据?': 'Confirm deletion of selected data?',
  '是否确认导出?': 'Confirm export?',

  // authUser / authRole module
  '用户名称': 'User name',
  '手机号码': 'Mobile number',
  '手机': 'Mobile',
  '添加用户': 'Add user',
  '取消批量授权': 'Batch cancel authorization',
  '取消授权': 'Cancel authorization',
  '确认要取消该用户的角色吗?': 'Confirm to cancel the role of this user?',
  '当前选中用户': 'Currently selected user: ',
  '取消授权成功': 'Authorization canceled successfully',
  '是否取消选中用户授权数据项?': 'Cancel authorization for selected users?',
  '角色名称': 'Role name',
  '权限字符': 'Permission key',

  // config module
  '参数名称': 'Config name',
  '参数分组': 'Config group',
  '参数键名': 'Config key',
  '参数键值': 'Config value',
  '参数类型': 'Config type',
  '是否多语言': 'Is multi-language',
  '系统内置': 'System built-in',
  '刷新成功': 'Refresh success',
  '参数名称不能为空': 'Config name cannot be empty',
  '参数键名不能为空': 'Config key cannot be empty',
  '参数键值不能为空': 'Config value cannot be empty',
  '添加参数': 'Add config',
  '修改参数': 'Edit config',
  '上传图片大小不能超过 20MB!': 'Image size cannot exceed 20MB!',
  '文本': 'Text',
  '富文本': 'Rich text',
  '请输入备注': 'Please enter remark',

  // dept module
  '上级部门': 'Parent dept',
  '负责人': 'Leader',
  '上级部门不能为空': 'Parent dept cannot be empty',
  '部门名称不能为空': 'Dept name cannot be empty',
  '排序不能为空': 'Sort cannot be empty',
  '请输入正确的邮箱地址': 'Please enter a valid email address',
  '请输入正确的手机号码': 'Please enter a valid mobile number',
  '添加部门': 'Add dept',
  '修改部门': 'Edit dept',

  // dict module
  '字典名称': 'Dict name',
  '字典类型': 'Dict type',
  '字典状态': 'Dict status',
  '请输入字典名称': 'Please enter dict name',
  '请输入字典类型': 'Please enter dict type',
  '字典编号': 'Dict id',
  '字典编码': 'Dict code',
  '字典标签': 'Dict label',
  '字典键值': 'Dict value',
  '字典排序': 'Dict sort',
  '字典名称不能为空': 'Dict name cannot be empty',
  '字典类型不能为空': 'Dict type cannot be empty',
  '添加字典类型': 'Add dict type',
  '修改字典类型': 'Edit dict type',
  '数据标签': 'Data label',
  '数据键值': 'Data value',
  '请输入数据标签': 'Please enter data label',
  '请输入数据键值': 'Please enter data value',
  '数据标签不能为空': 'Data label cannot be empty',
  '数据键值不能为空': 'Data value cannot be empty',
  '数据顺序不能为空': 'Data sort cannot be empty',
  '添加字典数据': 'Add dict data',
  '修改字典数据': 'Edit dict data',
  '请输入内容': 'Please enter content',
  '当前选中字典编号为': 'Currently selected dict id: ',
  '当前选中字典编码为': 'Currently selected dict code: ',

  // menu module
  '主目录': 'Root directory',
  '菜单名称不能为空': 'Menu name cannot be empty',
  '菜单顺序不能为空': 'Menu order cannot be empty',
  '路由地址不能为空': 'Route path cannot be empty',
  '组件路径不能为空': 'Component path cannot be empty',
  'parent': 'Parent',
  'type': 'Type',
  '目录': 'Directory',
  '菜单': 'Menu',
  '按钮': 'Button',
  'select icon': 'Select icon',
  'is url': 'Is URL',
  '选择是外链则路由地址需要以`http(s)://`开头': 'If you select an external link, the routing address needs to start with `http(s)://`',
  'path': 'Path',
  '访问的路由地址，如：`user`，如外网地址需内链访问则以`http(s)://`开头': 'The routing address to access, such as: `user`. If the external network address needs to be accessed via an internal link, start with `http(s)://`',
  '访问的组件路径，如：`system/user/index`，默认在`views`目录下': 'The component path to access, such as: `system/user/index`, under the `views` directory by default',
  '控制器中定义的权限字符，如：@PreAuthorize(`@ss.hasPermi(\'system:user:list\')`)': 'Permission characters defined in the controller, such as: @PreAuthorize(`@ss.hasPermi(\'system:user:list\')`)',
  '选择隐藏则路由将不会出现在侧边栏，但仍然可以访问': 'If hidden is selected, the route will not appear in the sidebar, but can still be accessed',
  '选择停用则路由将不会出现在侧边栏，也不能被访问': 'If disabled is selected, the route will not appear in the sidebar and cannot be accessed',
  'isCache': 'Is cache',
  '选择是则会被`keep-alive`缓存，需要匹配组件的`name`和地址保持一致，仅在多页签下有效。': 'If yes is selected, it will be cached by `keep-alive`. The component `name` and address must match. Only valid under multi-tab.',
  'add ': 'Add ',

  // post module
  '岗位编码': 'Post code',
  '岗位名称': 'Post name',
  '岗位编号': 'Post id',
  '岗位编码不能为空': 'Post code cannot be empty',
  '岗位名称不能为空': 'Post name cannot be empty',
  '显示顺序不能为空': 'Display order cannot be empty',
  '添加岗位': 'Add post',
  '修改岗位': 'Edit post',

  // notice module
  '公告类型不能为空': 'Notice type cannot be empty',
  '公告标题不能为空': 'Notice title cannot be empty',
  '添加公告': 'Add notice',
  '公告编辑': 'Edit notice',
  '修改公告': 'Edit notice',
  'user': 'User',

  // mask module
  '列名': 'Column name',
  '列名描述': 'Column description',
  '脱敏方向': 'Mask direction',
  '起始位置': 'Start index',
  '脱敏字符数': 'Mask char count',
  '是否开启': 'Is enabled',
  '从左向右': 'Left to right',
  '从右向左': 'Right to left',
  '要脱敏的列名不能为空': 'Column name to be masked cannot be empty',
  '列名描述不能为空': 'Column description cannot be empty',
  '脱敏方向不能为空': 'Mask direction cannot be empty',
  '脱敏起始位置不能为空': 'Mask start index cannot be empty',
  '脱敏字符数不能为空': 'Mask char count cannot be empty',
  '添加脱敏数据': 'Add mask data',
  '修改脱敏数据': 'Edit mask data',
  '操作成功！': 'Operation successful!',
  '请输入要脱敏的列名': 'Please enter column name to mask',
  '请输入列名描述': 'Please enter column description',
  '请输入脱敏起始位置': 'Please enter mask start index',
  '请输入脱敏字符数': 'Please enter mask char count',
  '确 定': 'OK',
  '取 消': 'Cancel',
  '是否脱敏': 'Is masked',
  '设置脱敏权限': 'Set mask permission',
  '的脱敏吗': ' mask?',

  // role data scope module
  '角色标识': 'Role key',
  '权限范围': 'Permission scope',
  '数据权限': 'Data permission',
  '展开/折叠': 'Expand/Collapse',
  '全选/全不选': 'Select all/None',
  '父子联动': 'Parent-child linkage',
  '当勾选项为空时方可切换模式，': 'The mode can only be switched when no items are checked,',
  '可以点击”全不选“后再次切换。': 'you can click "None" and then switch again.',
  '全部数据权限': 'All data permissions',
  '自定义数据权限': 'Custom data permissions',
  '本部门数据权限': 'Current dept data permissions',
  '本部门及以下数据权限': 'Current dept and below data permissions',
  '仅本人数据权限': 'Only self data permissions',
  '分配数据权限': 'Assign data permissions',

  // select user module
  // '选择用户': 'Select user',

  // user import module
  '用户导入': 'User import',
  '上传中...': 'Uploading...',
  '请将文件拖拽到此处上传❥(^_-)': 'Please drag the file here to upload',
  '支持单个上传，也可以点击后选择文件上传': 'Support single upload, or click to select a file to upload',
  '是否更新已经存在的用户数据': 'Whether to update existing user data',
  '下载模板': 'Download template',

  // reset password module
  '新密码': 'New password',
  '请确认密码': 'Please confirm password',
  '请输入5-20位英文字母、数字或者符号（除空格），且字母、数字和标点符号至少包含两种': 'Please enter 5-20 English letters, numbers or symbols (except spaces), and at least two of the letters, numbers and punctuation marks',
  '重置成功': 'Reset success',

  // common
  '搜索': 'Search',
  '吗？': '?',
  '修改失败': 'Update failed, ',
  '超级管理员角色信息 不可更改': 'Super administrator role information cannot be changed',
  '添加角色': 'Add role',
  '修改角色': 'Edit role',
  '角色名称不能为空': 'Role name cannot be empty',
  '权限字符不能为空': 'Permission key cannot be empty',
  '菜单权限': 'Menu permission',
  '要脱敏的列名': 'Column name to mask',

  // email module
  '本地邮件': 'Local Email',
  '阿里邮件': 'Aliyun Email',
  '腾讯邮件': 'Tencent Email',
  '阿里云邮件密匙ID': 'Aliyun Email Access Key ID',
  '阿里云邮件AccessKeyId': 'Aliyun Email AccessKeyId',
  '阿里云密钥SECRET': 'Aliyun Secret',
  '阿里云邮件AccessKeySecret': 'Aliyun Email AccessKeySecret',
  '阿里云区域ID': 'Aliyun Region ID',
  '阿里云邮件RegionId': 'Aliyun Email RegionId',
  '阿里云邮件AccessKeyId不能为空': 'Aliyun Email AccessKeyId cannot be empty',
  '阿里云邮件AccessKeySecret不能为空': 'Aliyun Email AccessKeySecret cannot be empty',
  '阿里云邮件RegionId不能为空': 'Aliyun Email RegionId cannot be empty',
  '腾讯云邮件密匙ID': 'Tencent Email Secret ID',
  '腾讯云邮件SecretId': 'Tencent Email SecretId',
  '腾讯云密钥SECRET': 'Tencent Secret',
  '腾讯云邮件SecretKey': 'Tencent Email SecretKey',
  '腾讯云区域ID': 'Tencent Region ID',
  '腾讯云邮件RegionId': 'Tencent Email RegionId',
  '腾讯云邮件SecretId不能为空': 'Tencent Email SecretId cannot be empty',
  '腾讯云邮件SecretKey不能为空': 'Tencent Email SecretKey cannot be empty',
  '腾讯云邮件RegionId不能为空': 'Tencent Email RegionId cannot be empty',
  '发送邮箱账号': 'Sender email account',
  '发送邮箱密码': 'Sender email password',
  '发送邮箱smtp': 'Sender email SMTP',
  '邮箱smtp': 'email SMTP',
  '可以省略，省略后默认为邮箱账号smtp.邮箱后缀,例如：邮箱账号为：zbtech@163.com，smtp为smtp.163.com': 'Can be omitted. If omitted, the default is smtp.email-suffix. For example, if the email account is zbtech@163.com, the SMTP is smtp.163.com',
  '邮箱账号不能为空': 'Email account cannot be empty',
  '邮箱密码不能为空': 'Email password cannot be empty',

  // activity rank module
  'SKU': 'SKU',
  '按用户ID': 'By User ID',
  '是否海外': 'Is Overseas',
  '用户参与活动排行': 'User Activity Ranking',
  '活动排行': 'Activity Ranking',

  // UserNationEnum (high frequency)
  '中国': 'China',
  '中国香港': 'Hong Kong (China)',
  '中国澳门': 'Macao (China)',
  '中国台湾': 'Taiwan (China)',
  '韩国': 'Korea',
  '朝鲜': 'North Korea',
  '日本': 'Japan',
  '美国': 'United States',
  '新加坡': 'Singapore',
  '马来西亚': 'Malaysia',
  '泰国': 'Thailand',
  '越南': 'Vietnam',
  '菲律宾': 'Philippines',
  '印度尼西亚': 'Indonesia',
  '印度': 'India',
  '加拿大': 'Canada',
  '澳大利亚': 'Australia',
  '英国': 'United Kingdom',
  '法国': 'France',
  '德国': 'Germany',
  '俄罗斯': 'Russia',
  '巴西': 'Brazil',

  // customer module
  '商户id': 'Merchant id',
  '商户编号': 'Merchant no',
  '商户code': 'Merchant code',
  '商户logo': 'Merchant logo',
  '是否激活': 'Is active',
  '是否前置分组': 'Is pre group',
  '分组id': 'Group id',
  '分组状态': 'Group status',
  '所属组织': 'Organization',
  '最大服务人数': 'Max service num',
  '分组': 'Group',
  '工作台': 'Workbench',
  '管理平台': 'Manage platform',
  '客服分组': 'Customer Group',
  '客服商户': 'Customer Merchant',
  '客服人员': 'Customer Staff',

  // coupon user drawer
  '优惠券领取记录': 'Coupon Receive Records',
  '领取人': 'Receiver',
  // '手机号': 'Mobile',
  '领取开始时间': 'Receive Start Time',
  '领取结束时间': 'Receive End Time',
  '过期开始时间': 'Expire Start Time',
  '过期结束时间': 'Expire End Time',
  '使用开始时间': 'Use Start Time',
  '使用结束时间': 'Use End Time',
  // '未使用': 'Unused',
  // '已使用': 'Used',
  // '已过期': 'Expired',
  // '已作废': 'Void',
  // '关闭': 'Close',
  '优惠券名称': 'Coupon Name',
  '优惠券类型': 'Coupon Type',
  '面额': 'Amount',
  '满多少元使用': 'Threshold Amount',
  '领取人姓名': 'Receiver Name',
  '领取人手机号': 'Receiver Mobile',
  '领取时间': 'Receive Time',
  '使用时间': 'Use Time',
  '过期时间': 'Expire Time',
  // '满减券': 'Full Reduction Coupon',
  // '折扣券': 'Discount Coupon',
  '折': 'Discount',
  // '共': 'Total',
  // '条': 'items',
  '确认删除所选中数据?': 'Confirm to delete the selected data?',
  '当前选中编号为': 'Currently selected data with id ',
  '的数据': '',
  //   '删除成功': 'Deleted successfully',

  // union alliance create form
  '推广者用户ID': 'Promoter User ID',
  '推广者昵称/姓名': 'Promoter Nickname/Name',
  '手机号': 'Mobile',
  '入驻时间': 'Join Time',
  '状态 0=禁用 1=正常 2=作废': 'Status 0=Disabled 1=Normal 2=Void',
  '邀请人数': 'Invite Count',
  '本月订单数': 'Month Orders',
  '累计订单数': 'Total Orders',
  '累计下单金额': 'Total Order Amount',
  '今日收益': 'Today Income',
  '本月收益': 'Month Income',
  '累计收益': 'Total Income',
  '待结算佣金': 'Pending Commission',
  '可提现佣金': 'Withdrawable Commission',

  // full gift activity
  '满赠活动': 'Full Gift Activities',
  '编辑': 'Edit',
  '查看': 'View',
  '保存成功': 'Saved successfully',
  '更新时间': 'Updated At',
  '发放成功': 'Issued successfully',
  '添加成功': 'Added successfully',
  '全部': 'All',
  '请输入活动名称': 'Please enter activity name',
  '请输入创建人账号或昵称': 'Please enter creator account or nickname',
  '活动状态': 'Activity Status',
  '请选择活动状态': 'Please select activity status',
  '已下架': 'Off Shelf',
  '未开始': 'Not Started',
  '已结束': 'Ended',
  '原价': 'Original Price',
  '实付': 'Amount Paid',
  '查看阶梯': 'View Tiers',
  '增加库存': 'Add Stock',
  '全部商品': 'All Goods',
  '指定商品': 'Specified Goods',
  '指定分类': 'Specified Categories',
  '范围': 'Scope',
  '门槛口径': 'Threshold Basis',
  '优先级': 'Priority',
  '阶梯概要': 'Tier Summary',
  '确认上架活动': 'Confirm putting activity on shelf',
  '确认下架活动': 'Confirm taking activity off shelf',
  '状态更新成功': 'Status updated successfully',
  '确认删除活动': 'Confirm deleting activity',
  '暂无阶梯': 'No tiers',
  '满': 'Spend',
  '赠品': 'gift SKUs',
  '种': 'types',
  '唯一优先级': 'Unique Priority',
  '适用范围': 'Applicable Scope',
  '排除商品': 'Excluded Goods',
  '选择排除商品': 'Select Excluded Goods',
  '请选择指定分类': 'Please select specified categories',
  '满赠阶梯': 'Full Gift Tiers',
  '阶梯': 'Tier',
  '删除阶梯': 'Delete Tier',
  '门槛金额': 'Threshold Amount',
  '阶梯库存': 'Tier Stock',
  '每人限领': 'Limit Per User',
  '选择赠品 SKU': 'Select Gift SKU',
  '添加阶梯': 'Add Tier',
  '新增满赠活动': 'Add Full Gift Activity',
  '请选择开始时间': 'Please select start time',
  '请选择结束时间': 'Please select end time',
  '请选择适用范围': 'Please select applicable scope',
  '请选择门槛口径': 'Please select threshold basis',
  '请输入唯一优先级': 'Please enter a unique priority',
  '赠送数量': 'Gift Quantity',
  '查看满赠活动（进行中不可编辑）': 'View Full Gift Activity (cannot edit while in progress)',
  '编辑满赠活动': 'Edit Full Gift Activity',
  '指定商品范围至少选择一个商品': 'Select at least one good for the specified goods scope',
  '指定分类范围至少选择一个分类': 'Select at least one category for the specified categories scope',
  '阶梯门槛必须严格递增且不可重复': 'Tier thresholds must increase and cannot be repeated',
  '库存必须大于 0': 'stock must be greater than 0',
  '限领必须大于 0': 'limit must be greater than 0',
  '至少选择一个赠品 SKU': 'select at least one gift SKU',
  '赠送数量必须大于 0': 'gift quantity must be greater than 0',
  '开始时间必须早于结束时间': 'Start time must be earlier than end time',
  '所选商品暂无可用 SKU': 'No available SKUs for the selected goods',
  'SKU 规格': 'SKU Specification',
  'SKU 编码': 'SKU Code',
  '可用库存': 'Available Stock',
  '请至少选择一个赠品 SKU': 'Please select at least one gift SKU',
  '增加阶梯库存': 'Add Tier Stock',
  '活动阶梯': 'Activity Tier',
  '请选择活动阶梯': 'Please select an activity tier',
  '剩余': 'Remaining',
  '增加数量': 'Quantity to Add',
  '请输入增加数量': 'Please enter the quantity to add',
  '库存增加成功': 'Stock added successfully',
  '满赠库存': 'Full Gift Stock',
  '活动 ID': 'Activity ID',
  '库存页面仅供查询；库存调整请在满赠活动列表对进行中的活动使用“增加库存”。': 'This page is read-only. Use Add Stock for an in-progress activity on the Full Gift Activities page.',
  '活动': 'Activity',
  '阶梯门槛': 'Tier Threshold',
  '总库存': 'Total Stock',
  '累计发放': 'Total Issued',
  '剩余库存': 'Remaining Stock',
  '赠品 SKU 快照': 'Gift SKU Snapshot',
  '限领': 'Limit',

  // RFM model
  'RFM 客户模型': 'RFM Customer Model',
  '7天内': 'Within 7 Days',
  '8-30天': '8-30 Days',
  '31-60天': '31-60 Days',
  '61-120天': '61-120 Days',
  '120天以上': 'Over 120 Days',
  '占比': 'Percentage',
  '客户分群': 'Customer Segment',
  '客户占比(%)': 'Customer Percentage (%)',
  '客户数': 'Customers',
  '平均距最近购买(天)': 'Average Days Since Last Purchase',
  '订单数': 'Orders',
  'Champions（超级用户）': 'Champions',
  'Loyal Customers（忠诚用户）': 'Loyal Customers',
  'Active（高潜忠诚）': 'Active',
  'New Customers（新客）': 'New Customers',
  'Promising（有希望用户）': 'Promising',
  'Need Attention（需要关注）': 'Need Attention',
  'Almost Lost（即将沉睡）': 'Almost Lost',
  'At Risk（流失风险）': 'At Risk',
  'Previously Loyal（曾经的忠诚用户）': 'Previously Loyal',
  'Dormant（休眠）': 'Dormant',
  'RFM 用户明细': 'RFM User Details',
  '分群': 'Segment',
  '评分分数': 'RFM Score',
  '近7天购买次数': 'Purchases in the Last 7 Days',
  '近7天花费': 'Spending in the Last 7 Days',
  'RFM用户明细': 'RFM User Details',

  // union management
  '邀请人': 'Inviter',
  '邀请状态': 'Invitation Status',
  '贡献佣金': 'Commission Contribution',
  '作废': 'Void',
  '下单人': 'Buyer',
  '请输入昵称或手机号': 'Please enter nickname or mobile number',
  '下单人昵称': 'Buyer Nickname',
  '下单人手机号': 'Buyer Mobile',
  '联盟者': 'Alliance Member',
  '商品图片': 'Goods Image',
  '获得佣金': 'Commission Earned',

  // recent coupon and review pages
  '优惠券': 'Coupon',
  '用户领券/发放记录': 'Coupon Receive and Issue Records',
  '评价管理': 'Review Management',
  '折扣比例': 'Discount Rate',
  '是否新人券：1是 0否': 'New User Coupon: 1 Yes, 0 No',
  '是否可积分兑换：1是 0否': 'Points Redeemable: 1 Yes, 0 No',
  '兑换所需积分': 'Points Required',
  '计划发放数量': 'Planned Issue Quantity',
  '已发出数量': 'Issued Quantity',
  '已被领取数量': 'Received Quantity',
  '已使用数量': 'Used Quantity',
  '商品分类ID': 'Goods Category ID',
  '状态：1启用 0禁用': 'Status: 1 Enabled, 0 Disabled',

  // community dashboard
  '跨境电商商城 · 社交互动分析大屏': 'Cross-Border E-commerce · Community Analytics Dashboard',
  '近 7 天': 'Last 7 Days',
  '近 30 天': 'Last 30 Days',
  '刷新数据': 'Refresh Data',
  '最后更新': 'Last Updated',
  '发帖数量': 'Posts',
  '发帖用户数': 'Posting Users',
  '带商品帖子数': 'Product Posts',
  '点赞用户数': 'Users Who Liked',
  '评论用户数': 'Users Who Commented',
  '当前统计周期': 'Current Period',
  '内容结构分析': 'Content Structure',
  '图文占比': 'Image & Text Share',
  '图文帖子数': 'Image & Text Posts',
  '视频帖子数': 'Video Posts',
  '互动转化率': 'Engagement Conversion Rates',
  '转化率 = 行为总数 ÷ 帖子曝光数': 'Rate = Total Actions ÷ Post Impressions',
  '点赞率': 'Like Rate',
  '评论率': 'Comment Rate',
  '收藏率': 'Favorite Rate',
  '分享率': 'Share Rate',
  '基于浏览量计算': 'Based on Page Views',
  '社区主题 TOP10': 'Top 10 Community Topics',
  '按互动总量排序': 'Ranked by Total Engagement',
  '带货用户 TOP10': 'Top 10 Product Promoters',
  '按带货订单数排序': 'Ranked by Product Orders',
  '社区带货转化数据': 'Community Commerce Conversions',
  '社区商品转化订单数': 'Community Product Orders',
  '基于帖子关联商品的已支付订单归因': 'Paid orders attributed to products linked in posts',
  '帖子曝光': 'Post Impressions',
  '商品点击': 'Product Clicks',
  '下单转化': 'Order Conversions',
  '加载失败': 'Load Failed',

  // withdrawal accounts and user actions
  '持卡人名称': 'Account Holder Name',
  '持卡人姓名': 'Account Holder Name',
  '开户行': 'Opening Bank',
  '请选择账户类型': 'Please select account type',
  '搜索用户昵称或ID选择': 'Search by user nickname or ID',
  '请选择用户': 'Please select a user',
  '账户类型不能为空': 'Account type cannot be empty',
  '持卡人姓名不能为空': 'Account holder name cannot be empty',
  '银行名称不能为空': 'Bank name cannot be empty',
  '银行卡号不能为空': 'Card number cannot be empty',
  '用户提现账户': 'User Withdrawal Accounts',
  '驳回原因': 'Rejection Reason',
  '请输入驳回原因': 'Please enter a rejection reason',
  '确认审核通过该批注销申请？': 'Approve the selected account cancellation requests?',
  '已驳回': 'Rejected',
  '确认禁用所选中数据?': 'Disable the selected data?',
  '禁用成功': 'Disabled successfully'
}
